'use strict';

var _ = require('lodash');
var RecommendationDetailsPanelController = function RecommendationDetailsPanelController($window, $scope, $rootScope, filterConfigService, recomDetailsCSVExportService, faresOptimizerConstants) {
  $scope.panel_disabled = false;
  $scope.chartModes = [{
    label: '',
    value: 'DATECHART',
    styleName: 'btn-default fa fa-calendar'
  }, {
    label: '',
    value: 'FARECHART',
    styleName: 'btn-default fa fa-usd'
  }];
  $scope.initializeState = function () {
    $scope.screenState.recommendChartMode = $scope.chartModes[0].value;
  };
  $scope.$watch('screenState.recommendationDetailsPanel.contextData', function () {
    var contextData = $scope.screenState.recommendationDetailsPanel.contextData;
    if (contextData && !_.isEmpty(contextData)) {
      $scope.entryLabels = contextData.entryLabels;
    }
  });
  $scope.backToOriginalScreen = function (screenMode) {
    if (faresOptimizerConstants.BENCHMARK_VIEW === screenMode && !_.isEmpty($window.sessionStorage[faresOptimizerConstants.SESSION_STORAGE_KEYS.RECALCULATED])) {
      $scope.$emit('foAnalysisToolbar:recalculatedFarePresent', {
        modalContent: 'isShowMovingAwayContent',
        ignoreApply: true
      });
      return false;
    }
    $scope.screenState.recommendationDetailsPanel.visible = false;
    $scope.screenState.recommendationDetailsPanel.ladderGroupChartDataList = [];
  };
  $scope.availableDetailsToolbarFilters = [];
  $scope.collapseFilter = function () {
    $scope.screenState.sideFilterExpanded = false;
  };
  $scope.loadFilterOptions = function () {
    $scope.availableDetailsToolbarFilters = filterConfigService.loadFiltersFromContextData($scope.screenState.recommendationDetailsPanel.contextData);
  };
  $scope.setInitialFilterValues = function () {
    $scope.screenState.detailsFilters = {};
    _.forEach($scope.availableDetailsToolbarFilters, function (filter) {
      $scope.screenState.detailsFilters[filter.filterId] = {};
      $scope.screenState.detailsFilters[filter.filterId].selected = _.map(filter.options, 'value');
      $scope.screenState.detailsFilters[filter.filterId].available = _.map(filter.options, 'value');
    });
  };
  $scope.initializeState();
  $scope.loadFilterOptions();
  $scope.setInitialFilterValues();
  $scope.$watch('screenState.detailsFilters', function () {
    if ($scope.screenState.recommendationDetailsMode === 'hostView') {
      $scope.$broadcast('hostViewFilter');
    }
  }, true);
  $scope.$on('comp_window_disable_panel', function () {
    $scope.panel_disabled = true;
  });
  $scope.$on('host_window_enable_panel', function () {
    $scope.panel_disabled = false;
  });
  $scope.exportToCSV = function () {
    if ($scope.screenState.recommendationDetailsMode === 'hostView') {
      recomDetailsCSVExportService.exportHostViewDateChartsDataToCSV($scope.screenState);
    }
    if ($scope.screenState.recommendationDetailsMode === 'competitiveView') {
      recomDetailsCSVExportService.exportCompViewDateChartsDataToCSV($scope.screenState);
    }
  };
};
RecommendationDetailsPanelController.$inject = ['$window', '$scope', '$rootScope', 'FaresOptimizerDetailsToolbarFilterService', 'RecommendationDetailsCSVExportService', 'FaresOptimizerConstants'];
module.exports = RecommendationDetailsPanelController;